import { css } from '@emotion/react';
import { color, spacing, typography } from '@uniquegood/realworld-studio-design';

import { maskEmail } from '../utils';

interface UserInfoCardProps {
  email: string;
  nickname: string;
  /** 이메일 마스킹 적용 여부. 채널 선택 후 노출이 필요한 경우 false. */
  maskEmail?: boolean;
}

/**
 * 학교 측에서 받아온 사용자 정보(이메일, 표시명) 표시 카드.
 * 디자인 시안의 user info 영역으로 사용된다.
 */
export default function UserInfoCard({
  email,
  nickname,
  maskEmail: shouldMask = true
}: UserInfoCardProps) {
  const displayedEmail = shouldMask ? maskEmail(email) : email;

  return (
    <dl css={styles.list} data-testid="connect-user-info">
      <div css={styles.row}>
        <dt css={styles.label}>표시명</dt>
        <dd css={styles.value}>{nickname}</dd>
      </div>
      <div css={styles.row}>
        <dt css={styles.label}>이메일</dt>
        <dd css={styles.value}>{displayedEmail}</dd>
      </div>
    </dl>
  );
}

const styles = {
  list: css`
    display: flex;
    flex-direction: column;
    gap: ${spacing.common.small};
    margin: 0;
    padding: ${spacing.common.medium};
    border: 1px solid ${color.border_default_subdued};
    border-radius: ${spacing.borderRadius.medium};
    background: ${color.surface_default_subdued};
  `,
  row: css`
    display: grid;
    grid-template-columns: 60px minmax(0, 1fr);
    gap: ${spacing.common.medium};
    color: ${color.text_default};
    font-size: ${typography.size.s2};
    line-height: 1.5;
  `,
  label: css`
    color: ${color.text_subdued};
    font-weight: ${typography.weight.medium};
    margin: 0;
  `,
  value: css`
    min-width: 0;
    margin: 0;
    overflow-wrap: anywhere;
    font-weight: ${typography.weight.regular};
  `
};
